export default "__VITE_ASSET__CSGE8NR4__"